import { logToDatadog } from "../services/datadog"
import { API_ERROR } from 'actions/actionTypes'

const slackNotifMiddleware = ({ getState }) => {
  return next => action => {
    if (action?.type === API_ERROR) {
        try {
          const error = action.payload.toJSON()
          logToDatadog("api_error", error, "error")
        } catch (_err) {
          logToDatadog("api_error", action.payload, "error")
        }

    }
    const returnValue = next(action)
    return returnValue
  }
}
export default slackNotifMiddleware;
